import React, { Component } from 'react'
import { Col, Card, CardBody, } from 'reactstrap'
import { Switch, Route, } from 'react-router-dom'
import {
  ManageUsersDistrictAdmin,
  ManageDistrictAdminsSelectorCard,
  ManageUsersSchoolAdmin,
  ManageSchoolAdminsSelectorCard,
  ManageUsersDistricts,
  ManageUsersSchools,
  ManageSchoolsSelectorCard,
  ManageUsersTeachers,
  ManageTeachersSelectorCard,
  ManageUsersClasses,
  ManageClassesSelectorCard,
  ManageUsersStudents,
  ManageStudentsSelectorCard,
  DeleteConfirmationModal,
  ManageTeachersAdd,
  ManageTeachersImport,
  ManageTeachersCodes,
  ManageStudentsAdd,
  ManageStudentsImport,
  ManageStudentsCodes,
  ManageSchoolAdminsAdd,
  ManageDistrictAdminsAdd,
  ManageSchoolsAdd,
  ManageDistrictsAdd,
  ManageClassesAdd,
  ManageUsersRedirect,
} from './'

class ManageUsersCard extends Component {
  render() {
    const { districts, schools, educators, students, classes, history } = this.props
    let search = ''
    if (this.props.location) {
      search = this.props.location.search
    }

    return (
      <div>
        <Switch>
          <Route path='/users/manage/district-admins/add/:id' render={(newProps) => <ManageDistrictAdminsAdd {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/district-admins/:id' render={(newProps) => <ManageUsersDistrictAdmin {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/district-admins' render={(newProps) => <ManageDistrictAdminsSelectorCard {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/school-admins/add/:id' render={(newProps) => <ManageSchoolAdminsAdd {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/school-admins/:id' render={(newProps) => <ManageUsersSchoolAdmin {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/school-admins' render={(newProps) => <ManageSchoolAdminsSelectorCard {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/districts/add' render={(newProps) => <ManageDistrictsAdd {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/districts' render={(newProps) => <ManageUsersDistricts {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/schools/add/:id' render={(newProps) => <ManageSchoolsAdd {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/schools/:id' render={(newProps) => <ManageUsersSchools {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/schools' render={(newProps) => <ManageSchoolsSelectorCard {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/teachers/codes/:id' render={(newProps) => <ManageTeachersCodes {...{ ...this.props, ...newProps, role: 'teacher' }} />} />
          <Route path='/users/manage/teachers/add/:id' render={(newProps) => <ManageTeachersAdd {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/teachers/import/:id' render={(newProps) => <ManageTeachersImport {...{ ...this.props, ...newProps, role: 'Teachers' }} />} />
          <Route path='/users/manage/teachers/:id' render={(newProps) => <ManageUsersTeachers {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/teachers' render={(newProps) => <ManageTeachersSelectorCard {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/classes/add/:id' render={(newProps) => <ManageClassesAdd {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/classes/:id' render={(newProps) => <ManageUsersClasses {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/classes' render={(newProps) => <ManageClassesSelectorCard {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/students/codes/:id' render={(newProps) => <ManageStudentsCodes {...{ ...this.props, ...newProps, role: 'student' }} />} />
          <Route path='/users/manage/students/import/:id' render={(newProps) => <ManageStudentsImport {...{ ...this.props, ...newProps, role: 'Students' }} />} />
          <Route path='/users/manage/students/add/:id' render={(newProps) => <ManageStudentsAdd {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/students/:id' render={(newProps) => <ManageUsersStudents {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage/students' render={(newProps) => <ManageStudentsSelectorCard {...{ ...this.props, ...newProps }} />} />
          <Route path='/users/manage' render={(newProps) => <ManageUsersRedirect {...{ ...this.props, ...newProps }} />} />
        </Switch>
        <Switch>
          <Route path='/users/manage' render={(newProps) => <DeleteConfirmationModal
            {...{ ...this.props, ...newProps, ...{ records: { districts, schools, educators, students, classes } } }}
          />} />
        </Switch>
      </div>


    )
  }
}

export default ManageUsersCard

// <DeleteConfirmationModal
// search={search}
// records={{districts, schools, educators, students, classes}}
// history={history}
// />


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManageUsersCard.js